import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_BASE_URL }),
  reducerPath: "adminApi",
  tagTypes: [
    "Users",
    "UserId",
    "Packages",
    "PackageId",
    "Customers",
    "CustomerId",
  ],
  endpoints: (build) => ({
    getUsers: build.query({
      query: () => "user/users",
      transformResponse: (response) => {
        // Handle standardized response format
        if (response.success) {
          return response.data;
        }
        throw new Error(response.message || 'API Error');
      },
      providesTags: ["Users"],
    }),
    getUserId: build.query({
      query: (id) => `user/${id}`,
      transformResponse: (response) => {
        // Handle standardized response format
        if (response.success) {
          return response.data;
        }
        throw new Error(response.message || 'API Error');
      },
      providesTags: ["UserId"],
    }),
    getPackages: build.query({
      query: ({ page, pageSize, sort, search }) => ({
        url: "package/packages",
        method: "GET",
        params: { page, pageSize, sort, search },
      }),
      transformResponse: (response) => {
        // Handle standardized response format
        if (response.success) {
          return response.data;
        }
        throw new Error(response.message || 'API Error');
      },
      providesTags: ["Packages"],
    }),
    getPackageId: build.query({
      query: (id) => `package/packageid/${id}`,
      transformResponse: (response) => {
        // Handle standardized response format
        if (response.success) {
          return response.data;
        }
        throw new Error(response.message || 'API Error');
      },
      providesTags: ["PackageId"],
    }),
    getCustomers: build.query({      
      query: ({ page, pageSize, sort, search }) => ({
        url: "customer/customers",
        method: "GET",
        params: { page, pageSize, sort, search },
      }),
      transformResponse: (response) => {
        // Handle standardized response format
        if (response.success) {
          return response.data;
        }
        throw new Error(response.message || 'API Error');
      },
      providesTags: ["Customers"],
    }),
    getCustomerId: build.query({
      query: (id) => `customer/customerid/${id}`,
      transformResponse: (response) => {
        // Handle standardized response format
        if (response.success) {
          return response.data;
        }
        throw new Error(response.message || 'API Error');
      },
      providesTags: ["CustomerId"],
    }),
    getProvinces: build.query({
      query: () => "location/provinces",
      providesTags: ["Provinces"],
    }),
    getDistricts: build.query({      
      query: ({pr_id}) =>({
        url: "location/districts",
        method: "GET",
        params: {pr_id}
      }),
      providesTags:["Districts"]
    })
  }),
});

export const {
  useGetUserIdQuery,
  useGetUsersQuery,
  useGetPackagesQuery,
  useGetPackageIdQuery,
  useGetCustomersQuery,
  useGetCustomerIdQuery,
  useGetProvincesQuery,
  useGetDistrictsQuery,
} = api;
